module.exports = __webpack_public_path__ + "static/media/logo.33d23cd6.svg";